<template>
  <div>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="cardListPush"
    :query-list="queryList"
    :is-show-store-select="true"
    :has-private-store="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
    :is-show-select-card-state="true"
    :is-show-select-card-type-id="true"
    :is-show-select-card-payment-mode-id="true"
    :is-show-select-card-is-new="true"
    :is-show-quick-time-tab="true"
    :is-show-quick-time-tab-week="false"
    :is-show-quick-time-tab-last-thirty-day="false"
    :is-show-quick-time-tab-month="true"
    :is-show-quick-time-tab-last-month="true"
    :is-show-xls-export-button="true"
    :isShowSelectCardChargeType="true"
    :isShowExpireNumbers="true"
    cardChargeTypeSelectLabel="课卡套餐"
    :isShowExportALl="true"
    :isExportingAll="isExporting"
    :exportAllText="`导出全部至 Excel${isExporting ? '（' + Math.min(currentExportPage * 30, count) + ' / ' + count + '）' : ''}`"
    :picker-options="pickerOptions"
    :show-summary="true"
    summary-title="本页合计"
    store-select-label="办理门店"
    cardTypeSelectLabel="课卡类型"
    cardStateSelectLabel="课卡状态"
    cardPaymentModeLabel="收款方式"
    quickTimeTabLabel="办卡日期"
    excel-name="课卡列表"
    :excel-data="xlsData"
    @exportAllExcel="exportAllExcel"
  >

    <template slot="header-item">
      <v-tab-quick-time
        :is-hide-quick-time="true"
        label="失效日期"
        v-model="timeLimitExpire"
        :picker-options="pickerOptionsOfAfterSystemStartDay"
        @input="handleTimeLimitExpireChange"
        size="small"
      />
    </template>

    <template slot="summary">
      <div v-if="!isMobile" class="is-new-summary">
        <template v-if="!isNewSummaryLoaded && !isNewSummaryError">
          <span class="is-new-summary-title">筛选结果（全量）</span>
          <span class="is-new-summary-skeleton"></span>
          <span class="is-new-summary-skeleton"></span>
          <span class="is-new-summary-skeleton is-new-summary-skeleton-total"></span>
        </template>
        <template v-else-if="isNewSummaryError">
          <span class="is-new-summary-title">筛选结果（全量）</span>
          <span class="is-new-summary-empty">统计加载失败，请刷新重试</span>
        </template>
        <template v-else-if="!isNewSummaryTotal.totalCount">
          <span class="is-new-summary-title">筛选结果（全量）</span>
          <span class="is-new-summary-empty">当前筛选条件下暂无办卡数据</span>
        </template>
        <template v-else>
          <span class="is-new-summary-title">筛选结果（全量）</span>
          <span>
            新生 <b>{{ isNewSummaryTotal.new.count }}</b> 张 /
            实付 <b>{{ isNewSummaryTotal.new.actual_payment | formatChineseMoney }}</b>元
            （占实付 {{ isNewSummaryTotal.newAmountPercent }}%）
          </span>
          <span>
            老生 <b>{{ isNewSummaryTotal.old.count }}</b> 张 /
            实付 <b>{{ isNewSummaryTotal.old.actual_payment | formatChineseMoney }}</b>元
            （占实付 {{ isNewSummaryTotal.oldAmountPercent }}%）
          </span>
          <span class="is-new-summary-total">
            合计 <b>{{ isNewSummaryTotal.totalCount }}</b> 张 /
            实付 <b>{{ isNewSummaryTotal.totalPayment | formatChineseMoney }}</b>元
          </span>
        </template>
      </div>
    </template>

    <v-column-time/>
    <v-column-time value="失效日期" field="expire_time" time-format="timeToYmdHi" empty-tip="-" sortable=""/>

    <el-table-column label="办卡门店" prop="store_name" width="104px"/>
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="新老生" width="68" type="isNotSummary">
      <template v-slot="{ row }">
        <el-tag
          v-if="getCardIsNewName(row.is_new)"
          size="mini"
          :type="Number(row.is_new) === 1 ? 'success' : 'info'"
        >
          {{ getCardIsNewName(row.is_new) }}
        </el-tag>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column label="课卡名称" prop="card_name"/>
    <el-table-column label="课卡类型" width="84">
      <template v-slot="{ row }">
        <span :title="row.card_type_name">{{ getCardTypeShortName(row.card_type_id, row.card_type_name) }}</span>
      </template>
    </el-table-column>

    <el-table-column label="有效天数">
      <template v-slot="{ row }">
        {{ row.expire_days }}
      </template>
    </el-table-column>

    <el-table-column label="剩余次数">
      <template v-slot="{ row }">
        <span v-if="row.is_number_limit">{{ row.expire_number | toYuan }}</span>
        <span v-else class="success-color">无限制</span>
      </template>
    </el-table-column>
    <el-table-column label="实付(元)" prop="actual_payment" type="money">
      <template v-slot="{ row }">
        <span>{{ row.actual_payment | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="收款方式">
      <template v-slot="{ row }">
        <span v-if="row.actual_payment">{{ findPaymentModeName(row.card_payment_mode_id) }}</span>
        <span v-else class="info-color">未付款</span>
      </template>
    </el-table-column>

    <el-table-column label="未消费(元)" prop="not_consumed_amount" type="money">
      <template v-slot="{ row }">
        <span>{{ row.not_consumed_amount | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="状态" width="62px">
      <template v-slot="{ row }">
        <span v-if="row.is_reviewing" class="warning-color">审核中</span>
        <span v-else-if="row.is_locked" class="warning-color">锁定中</span>
        <span v-else-if="row.is_stopped" class="danger-color">停卡中</span>
        <template v-else>
          <span v-if="row.is_number_limit && !row.expire_number" class="info-color">已用完</span>
          <span v-else-if="row.is_expired" class="info-color">已过期</span>
          <span v-else-if="!row.expire_time" class="primary-color">未开卡</span>
          <span v-else-if="row.is_archive" class="info-color">已归档</span>
          <span v-else class="success-color">可使用</span>
        </template>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="250">
      <template v-slot="{ row }">
        <!-- 停卡中的课卡禁止修改/退卡（后端同样拦截），只保留查看与超管的提前开卡 -->
        <template v-if="!row.is_stopped">
          <v-list-button icon="update-date" name="延期" :to="cardEditDateTo(row.id)"/>
          <v-list-button icon="update-number" name="改次" :to="cardEditNumberTo(row.id)"/>
        </template>

        <v-popover :name="!row.is_locked && !row.is_stopped ? '退卡' : ''" :to="cardDeleteTo(row.id)">
          <template v-if="!row.is_stopped">
            <v-popover-item icon="update-type" name="修改类型" :to="cardEditTypeTo(row.id)"/>
            <v-popover-item icon="update-all" name="修改全部" :to="cardEditTo(row.id)"/>
          </template>

          <template v-if="!row.is_reviewing">
            <!-- 锁定/解锁仅超管可操作（后端 check.administrator），普通管理员不展示 -->
            <template v-if="isAdministrator && !row.is_stopped">
              <v-popover-item
                v-if="row.is_locked"
                icon="unlock"
                name="解锁课卡"
                @click="handleUnlock(row)"
                :is-loading="isLockingIds.includes(row.id)"
                message="课卡解锁后将恢复使用，确认要解锁此课卡吗？"
              />

              <v-popover-item
                v-else
                icon="lock"
                name="锁定课卡"
                @click="handleLock(row)"
                :is-loading="isLockingIds.includes(row.id)"
                message="锁卡后将无法使用，确认要锁定此课卡吗？"
              />
            </template>

            <template v-if="!row.is_locked">
              <v-popover-item
                v-if="isAdministrator && row.is_stopped"
                icon="unstop"
                name="提前开卡"
                @click="handleUnstop(row)"
                :is-loading="isStoppingIds.includes(row.id)"
                :message="unstopMessage(row)"
              />
              <v-popover-item
                v-else-if="canUseStopEntry(row)"
                :icon="isAdministrator ? 'stop' : 'mini-app-qr-code'"
                :name="isAdministrator ? '停用课卡' : '学员停卡'"
                @click="isAdministrator ? openStopDialog(row) : openStopQrCode(row)"
                :is-loading="isStoppingIds.includes(row.id) || isQrCodeLoadingId === row.id"
              />
            </template>
          </template>

          <v-popover-item icon="view" name="查看课卡" :to="RouteConfig.cardDetail.to(row.id)"/>
        </v-popover>

      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :link-page-name="studentDetailName"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>课卡 ID</span>
              <span>{{ v.id }}</span>
            </div>
            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>失效日期</span>
              <span>{{ v.expire_time | timeToYmdHi }}</span>
            </div>
            <div class="list-item-detail">
              <span>办卡门店</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课卡名称</span>
              <span>{{ v.card_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课卡类型</span>
              <span :title="v.card_type_name">{{ getCardTypeShortName(v.card_type_id, v.card_type_name) }}</span>
            </div>
            <div class="list-item-detail">
              <span>新老生</span>
              <span v-if="Number(v.is_new) === 1" class="success-color">新生</span>
              <span v-else-if="Number(v.is_new) === 0" class="info-color">老生</span>
              <span v-else>-</span>
            </div>
            <div class="list-item-detail">
              <span>有效天数</span>
              <span>{{ v.expire_days }} 天</span>
            </div>
            <div class="list-item-detail">
              <span>剩余次数</span>
              <span>{{ v.expire_number | toYuan }} 次</span>
            </div>
            <div class="list-item-detail">
              <span>实付</span>
              <span>{{ v.actual_payment | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>收款方式</span>
              <span>{{ findPaymentModeName(v.card_payment_mode_id) }}</span>
            </div>
            <div class="list-item-detail">
              <span>未消费</span>
              <span>{{ v.not_consumed_amount | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>状态</span>
              <span v-if="v.is_reviewing" class="warning-color">审核中</span>
              <span v-else-if="v.is_locked" class="warning-color">锁定中</span>
              <span v-else-if="v.is_stopped" class="danger-color">停卡中</span>
              <template v-else>
                <span v-if="!v.expire_time" class="primary-color">未开卡</span>
                <span v-else-if="v.is_number_limit && !v.expire_number" class="info-color">已用完</span>
                <span v-else-if="v.is_expired" class="info-color">已过期</span>
                <span v-else-if="v.is_archive" class="info-color">已归档</span>
                <span v-else class="success-color">可使用</span>
              </template>
            </div>
            <div class="list-item-button">
              <template v-if="!v.is_stopped">
                <v-list-button icon="update-date" name="延期" :to="cardEditDateTo(v.id)"/>
                <v-list-button icon="update-number" name="改次" :to="cardEditNumberTo(v.id)"/>
              </template>

              <v-popover :name="!v.is_locked && !v.is_stopped ? '退卡' : ''" :to="cardDeleteTo(v.id)">
                <template v-if="!v.is_stopped">
                  <v-popover-item icon="update-type" name="修改类型" :to="cardEditTypeTo(v.id)"/>
                  <v-popover-item icon="update-all" name="修改全部" :to="cardEditTo(v.id)"/>
                </template>

                <template v-if="!v.is_reviewing">
                  <!-- 锁定/解锁仅超管可操作（后端 check.administrator），普通管理员不展示 -->
                  <template v-if="isAdministrator && !v.is_stopped">
                    <v-popover-item
                      v-if="v.is_locked"
                      icon="unlock"
                      name="解锁课卡"
                      @click="handleUnlock(v)"
                      :is-loading="isLockingIds.includes(v.id)"
                      message="课卡解锁后将恢复使用，确认要解锁此课卡吗？"
                    />

                    <v-popover-item
                      v-else
                      icon="lock"
                      name="锁定课卡"
                      @click="handleLock(v)"
                      :is-loading="isLockingIds.includes(v.id)"
                      message="锁卡后将无法使用，确认要锁定此课卡吗？"
                    />
                  </template>

                  <template v-if="!v.is_locked">
                    <v-popover-item
                      v-if="isAdministrator && v.is_stopped"
                      icon="unstop"
                      name="提前开卡"
                      @click="handleUnstop(v)"
                      :is-loading="isStoppingIds.includes(v.id)"
                      :message="unstopMessage(v)"
                    />
                    <v-popover-item
                      v-else-if="canUseStopEntry(v)"
                      :icon="isAdministrator ? 'stop' : 'mini-app-qr-code'"
                      :name="isAdministrator ? '停用课卡' : '学员停卡'"
                      @click="isAdministrator ? openStopDialog(v) : openStopQrCode(v)"
                      :is-loading="isStoppingIds.includes(v.id) || isQrCodeLoadingId === v.id"
                    />
                  </template>
                </template>

                <v-popover-item icon="view" name="查看课卡" :to="RouteConfig.cardDetail.to(v.id)"/>
              </v-popover>
            </div>
          </div>

          <div class="list-item list-count-box primary-background-light">
            <div class="list-item-detail">
              <strong>本页合计</strong>
            </div>
            <div class="list-item-detail">
              <span>实付</span>
              <span>{{ actual_payment | toYuan }} 元</span>
            </div>
            <div class="list-item-detail">
              <span>未消费</span>
              <span>{{ not_consumed_amount | toYuan }} 元</span>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>

  <el-dialog
    title="停用课卡"
    :visible.sync="isStopDialogVisible"
    width="420px"
    @closed="resetStopDialog"
  >
    <el-form label-position="right" label-width="100px">
      <el-form-item label="停卡天数">
        <v-input-number
          class="w100"
          v-model="stopDays"
          type="unsignedSmallInt"
          :min="0.5"
          :max="365"
          :precision="2"
          :is-show-suffix="true"
          suffix-name="天"
          placeholder="请输入 0.5 ~ 365 天"
        />
        <div v-if="isStopDaysInvalid" class="danger-color">低于下限，离开输入框后会自动调整为 0.5 天</div>
        <div v-else class="info-color">可填 0.5 ~ 365 天，支持两位小数</div>
      </el-form-item>
    </el-form>
    <el-alert
      title="停卡期间该课卡不可使用，到期后系统自动开卡；也可随时提前开卡。"
      type="info"
      show-icon
      :closable="false"
    />
    <div slot="footer">
      <el-button @click="isStopDialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="isStopSaving" @click="confirmStop">确认停卡</el-button>
    </div>
  </el-dialog>

  <el-dialog
    title="学员停卡申请二维码"
    :visible.sync="isQrCodeDialogVisible"
    :width="isMobile ? '90%' : '420px'"
    custom-class="qr-code-dialog"
    @closed="resetQrCodeDialog"
  >
    <div v-if="qrCodeUrl" class="qr-code-box">
      <div class="qr-code-image-wrap">
        <img class="qr-code-image" :src="qrCodeUrl" alt="停卡申请二维码"/>
      </div>
      <div class="qr-code-tip">微信扫码进入停卡申请</div>
      <div class="qr-code-info">
        <div class="qr-code-row">
          <span class="qr-code-label">所属学员</span>
          <span class="qr-code-value">{{ qrCodeCard.student_name }}</span>
        </div>
        <div class="qr-code-row">
          <span class="qr-code-label">课卡名称</span>
          <span class="qr-code-value">{{ qrCodeCard.card_name }}</span>
        </div>
        <div class="qr-code-row">
          <span class="qr-code-label">课卡 ID</span>
          <span class="qr-code-value">{{ qrCodeCard.id }}</span>
        </div>
      </div>
    </div>
    <div v-else class="qr-code-loading info-color">二维码生成中...</div>
    <div class="qr-code-alert">
      <el-alert
        title="仅限该课卡所属学员本人扫码，其他学员扫码无法申请。"
        type="info"
        show-icon
        :closable="false"
      />
    </div>
  </el-dialog>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import exportExcel from '@/utils/excel-export';
import { mapGetters } from 'vuex';
import { getLegalQueryList, pickerOptionsOfAfterSystemStartDay } from '@/utils/formats';
import { checkYmdIsBetweenSetUpAndToday } from "@/utils/validate";
import { timeToYmd, timeToYmdHi, toYuan, plus, toCent } from "@/filters";
import { removeArrayItem } from "@/utils";
import { findPaymentModeName } from "@/enums/paymentModes";
import { cardQrCodeTypes } from "@/enums/cardQrCodeTypes";
import { getCardIsNewName } from "@/enums/cardIsNewTypes";
import { getCardTypeNameByType } from "@/enums/cardTypes";
import {
  index,
  lock,
  stop,
  unlock,
  unstop,
  getQrCode,
  getIsNewSummary,
} from '@/api/card';

export default {
  name: RouteConfig.cardList.name,
  data: () => ({
    RouteConfig,
    cardListPush: RouteConfig.cardList.push,
    studentDetailName: RouteConfig.studentDetail.name,

    cardEditDateTo: RouteConfig.cardEditDate.to,
    cardEditNumberTo: RouteConfig.cardEditNumber.to,
    cardEditTypeTo: RouteConfig.cardEditType.to,
    cardEditTo: RouteConfig.cardEdit.to,
    cardDeleteTo: RouteConfig.cardDelete.to,
    count: 0,
    actual_payment: 0,
    not_consumed_amount: 0,
    list: [],
    xlsData: [],
    queryList: {
      keyword: '',
      store_id: '',
      card_state: 0,
      is_new: '',
      card_type_id: 0,
      card_payment_mode_id: 0,
      start_date: '',
      end_date: '',
      start_date_expire: '',
      end_date_expire: '',
      expire_number_min: '',
      expire_number_max: '',
      is_asc: 0,
      page: 1,
      size: 10,
    },
    pickerOptionsOfAfterSystemStartDay,
    pickerOptions: {
      disabledDate: (time) => time.getTime() >= Date.now(),
    },
    isLoading: false,
    isExporting: false,
    currentExportPage: 0,
    timeLimit: [],
    timeLimitExpire: [],
    isLockingIds: [],
    isStoppingIds: [],
    isStopDialogVisible: false,
    isStopSaving: false,
    stopCardId: 0,
    stopDays: 30,
    isQrCodeDialogVisible: false,
    isQrCodeLoadingId: 0,
    qrCodeCard: {},
    qrCodeUrl: '',
    isNewSummary: [],
    isNewSummaryLoaded: false,
    isNewSummaryError: false,
    isNewSummaryRequestId: 0,
    lastIsNewSummaryKey: '',
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
    queryList(queryList) {
      this.timeLimit = [queryList.start_date, queryList.end_date];
      this.timeLimitExpire = [queryList.start_date_expire, queryList.end_date_expire];
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
      'defaultStoreId',
      'isMobile',
    ]),
    // 输入组件对「上限」是实时钳制、对「下限」是失焦钳制（否则想输 0.5 会被打断）。
    // 所以这里只对「低于下限」给红字提示；空值不报红，交给提交校验兜底。
    isStopDaysInvalid() {
      if (this.stopDays === '' || this.stopDays === null || this.stopDays === undefined) return false;
      const days = Number(this.stopDays);
      return !(Number.isFinite(days) && days >= 0.5 && days <= 365);
    },
    isNewSummaryTotal() {
      const summary = Array.isArray(this.isNewSummary) ? this.isNewSummary : [];
      const find = (isNew) => summary.find(item => Number(item.is_new) === isNew)
        || { count: 0, actual_payment: 0 };
      const newItem = find(1);
      const oldItem = find(0);
      const totalCount = plus(newItem.count, oldItem.count);
      const totalPayment = plus(newItem.actual_payment, oldItem.actual_payment);
      const percent = (value) => (totalPayment
        ? Math.round(value / totalPayment * 1000) / 10
        : 0);

      return {
        new: newItem,
        old: oldItem,
        totalCount,
        totalPayment,
        newAmountPercent: percent(newItem.actual_payment),
        oldAmountPercent: percent(oldItem.actual_payment),
      };
    },
  },
  beforeMount() {
    this.load();
  },
  methods: {
    findPaymentModeName,
    getCardIsNewName,
    // 后端可能把 card_type_id 序列化成字符串，这里统一转成数字再匹配固定枚举；
    // 枚举里没有的新类型回退显示全名，避免以后加类型时整列变成短横线
    getCardTypeShortName(cardTypeId, cardTypeName) {
      return getCardTypeNameByType(Number(cardTypeId)) || cardTypeName || '-';
    },
    getStateName(item) {
      if (item.is_reviewing) return '审核中';
      if (item.is_locked) return '锁定中';
      if (item.is_stopped) return '停卡中';
      if (!item.expire_time) return '未开卡';
      if (item.is_number_limit && !item.expire_number) return '已用完';
      if (item.is_expired) return '已过期';
      return '可使用';
    },
    setXlsData(list) {
      let xlsData = [];
      list.forEach(item => {
        xlsData.push({
          '课卡ID': item.id,
          '添加时间': timeToYmdHi(item.add_time),
          '办卡日期': timeToYmd(item.register_time),
          '开卡时间': timeToYmdHi(item.start_time, '未开卡'),
          '办卡门店': item.store_name,
          '操作人员': item.administrator_nickname,
          '所属学员': item.student_name,
          '新老生': getCardIsNewName(item.is_new) || '-',
          '学员手机号': item.phone,
          '课卡名称': item.card_name,
          '课卡类型': item.card_type_name,
          '有效天数': item.expire_days,
          '失效日期': timeToYmdHi(item.expire_time, '未开卡'),
          '剩余次数': item.is_number_limit ? toYuan(item.expire_number) : '-',
          '课卡状态': this.getStateName(item),
          '实际收款': toYuan(item.actual_payment),
          '收款方式': findPaymentModeName(item.card_payment_mode_id),
          '有赞券码': item.you_zan_number || '',
          '未消费金额': toYuan(item.not_consumed_amount),
        });
      });
      return xlsData;
    },
    async exportAllExcel() {
      if (this.isExporting) return;

      if (!this.count) return this.$message({
        message: '暂无数据可以导出',
        type: 'info',
        duration: 5000,
      });

      const isConfirm = await this.$confirm(
        `此操作将导出共计 ${this.count} 条数据, 导出过程中不可关闭此页面，确定是否要继续？`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        },
      ).catch(() => {});
      if (!isConfirm) return;

      this.isExporting = true;
      try {
        // 拷贝当前筛选条件，逐页翻查时不污染页面状态
        const params = { ...this.queryList };
        getLegalQueryList(params, this.$route.query);

        const startDateIsValid = checkYmdIsBetweenSetUpAndToday(this.$route.query.start_date);
        const endDateIsValid = checkYmdIsBetweenSetUpAndToday(this.$route.query.end_date);

        if (startDateIsValid && endDateIsValid) {
          params.start_date = this.$route.query.start_date;
          params.end_date = this.$route.query.end_date;
        } else {
          params.start_date = '';
          params.end_date = '';
        }

        // 剩余次数筛选与列表查询保持一致（存储值=实际值×100）
        params.expire_number_min = toCent(params.expire_number_min);
        params.expire_number_max = toCent(params.expire_number_max);

        Object.assign(params, {
          is_only_list: 1, // 只取列表，不计数
          page: 1,
          size: 30,
        });

        let xlsData = [];
        const maxPage = Math.ceil(this.count / 30);
        for (let page = 1; page <= maxPage; page++) {
          params.page = page;
          this.currentExportPage = page;
          const { isError, data } = await index(params);
          if (isError || !data) {
            this.$message({
              message: '导出失败，请重试',
              type: 'error',
              duration: 5000,
            });
            return;
          }
          xlsData = xlsData.concat(data);
        }

        exportExcel(this.setXlsData(xlsData), '课卡列表');
      } finally {
        this.isExporting = false;
      }
    },
    // 只把真正影响统计的筛选字段纳入签名：
    // 首次进入 /cards 时没有参数，翻页后路由会补上 card_state=0、空数组等默认值，
    // 如果直接 JSON.stringify(params)，会被误判成筛选变化而重复请求统计。
    getIsNewSummaryKey(params) {
      const toText = (value) => (Array.isArray(value) ? value.join(',') : (value || ''));
      const toNumber = (value) => Number(value) || 0;
      const normalizeIsNew = (value) => {
        if (value === 0 || value === '0') return 0;
        if (value === 1 || value === '1') return 1;
        return '';
      };

      return JSON.stringify({
        store_id: toNumber(params.store_id),
        store_ids: toText(params.store_ids),
        student_ids: toText(params.student_ids),
        card_state: toNumber(params.card_state),
        is_new: normalizeIsNew(params.is_new),
        card_type_id: toNumber(params.card_type_id),
        card_charge_type_id: toNumber(params.card_charge_type_id),
        card_payment_mode_id: toNumber(params.card_payment_mode_id),
        card_type_ids: toText(params.card_type_ids),
        card_charge_type_ids: toText(params.card_charge_type_ids),
        keyword: toText(params.keyword),
        start_date: toText(params.start_date),
        end_date: toText(params.end_date),
        start_date_expire: toText(params.start_date_expire),
        end_date_expire: toText(params.end_date_expire),
        expire_number_min: toNumber(params.expire_number_min),
        expire_number_max: toNumber(params.expire_number_max),
      });
    },
    // 独立统计接口：只在筛选条件变化时请求一次，翻页不重复请求
    async loadIsNewSummary(params) {
      const summaryParams = { ...params };
      delete summaryParams.page;
      delete summaryParams.size;
      delete summaryParams.is_asc;
      delete summaryParams.order_by;

      const key = this.getIsNewSummaryKey(summaryParams);
      if (key === this.lastIsNewSummaryKey) return;

      this.lastIsNewSummaryKey = key;
      // 筛选条件变了先切回骨架占位，避免短暂显示上一组筛选的数字
      this.isNewSummaryLoaded = false;
      this.isNewSummaryError = false;
      const requestId = ++this.isNewSummaryRequestId;
      const { isError, data } = await getIsNewSummary(summaryParams);
      if (requestId !== this.isNewSummaryRequestId) return;

      if (isError) {
        this.lastIsNewSummaryKey = '';
        this.isNewSummaryLoaded = false;
        this.isNewSummaryError = true;
        return;
      }

      this.isNewSummary = Array.isArray(data) ? data : [];
      this.isNewSummaryError = false;
      this.isNewSummaryLoaded = true;
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, query);

      const startDateIsValid = checkYmdIsBetweenSetUpAndToday(query.start_date);
      const endDateIsValid = checkYmdIsBetweenSetUpAndToday(query.end_date);

      if (startDateIsValid && endDateIsValid) {
        queryList.start_date = query.start_date;
        queryList.end_date = query.end_date;
      } else {
        queryList.start_date = '';
        queryList.end_date = '';
      }

      const params = { ...queryList };
      params.expire_number_min = toCent(queryList.expire_number_min);
      params.expire_number_max = toCent(queryList.expire_number_max);

      // 统计接口独立请求，不阻塞列表；翻页时 key 不变会自动跳过
      this.loadIsNewSummary(params);

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      const xlsData = [];
      let actual_payment = 0;
      let not_consumed_amount = 0;
      data.list.forEach(item => {
        xlsData.push({
          '课卡ID': item.id,
          '添加时间': timeToYmdHi(item.add_time),
          '办卡日期': timeToYmd(item.register_time),
          '开卡时间': timeToYmdHi(item.start_time, '未开卡'),
          '办卡门店': item.store_name,
          '操作人员': item.administrator_nickname,
          '所属学员': item.student_name,
          '新老生': getCardIsNewName(item.is_new) || '-',
          '学员手机号': item.phone,
          '课卡名称': item.card_name,
          '课卡类型': item.card_type_name,
          '有效天数': item.expire_days,
          '失效日期': timeToYmdHi(item.expire_time, '未开卡'),
          '剩余次数': item.is_number_limit ? toYuan(item.expire_number) : '-',
          '课卡状态': this.getStateName(item),
          '实际收款': toYuan(item.actual_payment),
          '收款方式': findPaymentModeName(item.card_payment_mode_id),
          '有赞券码': item.you_zan_number || '',
          '未消费金额': toYuan(item.not_consumed_amount),
        });
        actual_payment = plus(actual_payment, item.actual_payment);
        not_consumed_amount = plus(not_consumed_amount, item.not_consumed_amount);
      });

      this.count = data.count;
      this.list = data.list;
      this.xlsData = xlsData;
      this.actual_payment = actual_payment;
      this.not_consumed_amount = not_consumed_amount;
      if (next) next();
    },
    refresh() {
      RouteConfig.cardList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleTimeLimitChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date, end_date] = times;

      Object.assign(this.queryList, {
        start_date,
        end_date,
        page: 1,
      });
      this.refresh();
    },
    handleTimeLimitExpireChange(times) {
      if (!times || !times.length) times = ['', ''];

      this.timeLimit = times;
      const [start_date_expire, end_date_expire] = times;

      Object.assign(this.queryList, {
        start_date_expire,
        end_date_expire,
        page: 1,
      });
      this.refresh();
    },
    handleExpireNumbersChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async handleLock({ id }) {
      this.isLockingIds.push(id);
      const { isError } = await lock(id);
      removeArrayItem(this.isLockingIds, id);
      if (!isError) this.load();
    },
    async handleUnlock({ id }) {
      this.isLockingIds.push(id);
      const { isError } = await unlock(id);
      removeArrayItem(this.isLockingIds, id);
      if (!isError) this.load();
    },
    // 停卡仅在「已开卡且在有效期内、未停卡、且（次卡）还有剩余次数」时才有意义，与后端手动停卡守卫保持一致。
    // 未开卡/已过期/次数用完/已停卡/已归档都只是白白产生停卡+提前开卡两条记录。
    canStopCard(card) {
      return !card.is_stopped
        && !!card.expire_time
        && !card.is_expired
        && !(card.is_number_limit && card.expire_number <= 0)
        && !card.is_archive;
    },
    // 「停卡」入口是否可用：超管走手动停卡（状态满足即可，后端 stop 不校验套餐天数，不受套餐限制）；
    // 非超管走学员自助申请二维码，需套餐配置了停卡天数（stop_days=0 即不支持停卡），
    // 与小程序 CardStopService::getStopInfo 及后台二维码接口的拦截口径一致。
    canUseStopEntry(card) {
      if (!this.canStopCard(card)) return false;
      return this.isAdministrator || card.stop_days > 0;
    },
    // 打开停卡弹窗：天数用 v-input-number（带「天」后缀，0.5 ~ 365），与学员停卡申请同一套天数规则
    openStopDialog({ id }) {
      if (!id) return;
      this.stopCardId = id;
      this.stopDays = 30;
      this.isStopDialogVisible = true;
    },
    resetStopDialog() {
      this.stopCardId = 0;
      this.stopDays = 30;
    },
    // 非超管（店长/前台/顾问）不直接停卡，而是生成小程序码让学员本人自助申请
    async openStopQrCode(row) {
      if (!row.id || this.isQrCodeLoadingId) return;

      this.isQrCodeLoadingId = row.id;
      const { isError, data } = await getQrCode(row.id, { qr_type: cardQrCodeTypes.stop });
      this.isQrCodeLoadingId = 0;
      if (isError || !data.qr_code) return;

      this.qrCodeCard = row;
      this.qrCodeUrl = data.qr_code;
      this.isQrCodeDialogVisible = true;
    },
    resetQrCodeDialog() {
      this.qrCodeCard = {};
      this.qrCodeUrl = '';
    },
    async confirmStop() {
      if (this.isStopSaving) return;

      const stopDays = Number(this.stopDays);
      if (!(Number.isFinite(stopDays) && stopDays >= 0.5 && stopDays <= 365)) {
        return this.$message.warning('停卡天数需在 0.5 ~ 365 天之间。');
      }

      this.isStopSaving = true;
      const { isError } = await stop(this.stopCardId, { stop_days: toCent(stopDays) });
      this.isStopSaving = false;
      if (isError) return;

      this.isStopDialogVisible = false;
      this.load();
    },
    // 提前开卡确认文案：给出停卡起始、已停时长、自动开卡时间与顺延后的失效日期，而不是只问“是否继续”
    unstopMessage(card) {
      if (!card || !card.stop_time) return '确认要提前开卡吗？';

      const now = Math.floor(Date.now() / 1000);
      const stoppedSeconds = Math.max(0, now - card.stop_time);
      const projected = card.expire_time ? card.expire_time + stoppedSeconds : 0;
      const autoOpen = card.stop_expire_time
        ? `系统将于 ${timeToYmdHi(card.stop_expire_time)} 自动开卡`
        : '该课卡为无固定期限停卡，不自动开卡';
      const expireText = projected
        ? `失效日期由 ${timeToYmdHi(card.expire_time)} 顺延至约 ${timeToYmdHi(projected)}`
        : '当前未开卡';

      return `该课卡 ${timeToYmdHi(card.stop_time)} 停卡，已停 ${this.formatStopDuration(stoppedSeconds)}；${autoOpen}。提前开卡后立即恢复使用，${expireText}。确认要提前开卡吗？`;
    },
    // 已停时长（天+小时 / 小时+分钟 / 分钟）：列表页没有服务端算好的时长，按当前时间估算即可
    formatStopDuration(seconds) {
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor((seconds % 86400) / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      if (days > 0) return hours > 0 ? `${days} 天 ${hours} 小时` : `${days} 天`;
      if (hours > 0) return minutes > 0 ? `${hours} 小时 ${minutes} 分钟` : `${hours} 小时`;
      return `${Math.max(minutes, 1)} 分钟`;
    },
    async handleUnstop({ id }) {
      this.isStoppingIds.push(id);
      const { isError } = await unstop(id);
      removeArrayItem(this.isStoppingIds, id);
      if (!isError) this.load();
    },
  },
};
</script>

<style src="./index.css" scoped/>
